(function () {
  'use strict';

  function normalize(value) {
    return value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  }

  function initFAQ(section) {
    if (section.dataset.faqReady) return;
    section.dataset.faqReady = 'true';
    var search = section.querySelector('[data-faq-search]');
    var input = section.querySelector('[data-faq-input]');
    var count = section.querySelector('[data-faq-count]');
    var empty = section.querySelector('[data-faq-empty]');
    var items = Array.from(section.querySelectorAll('[data-faq-item]'));
    var groups = Array.from(section.querySelectorAll('[data-faq-group]'));
    var categories = Array.from(section.querySelectorAll('[data-faq-category]'));
    var previousQuery = '';
    var openBeforeSearch = new Set();
    var searchable = new Map(items.map(function (item) {
      return [item, normalize(item.textContent)];
    }));

    function filter() {
      var query = normalize(input.value);
      var words = query.split(' ').filter(Boolean);
      if (query && !previousQuery) {
        openBeforeSearch = new Set(items.filter(function (item) { return item.open; }));
      }
      var matches = 0;
      items.forEach(function (item) {
        var match = words.every(function (word) { return searchable.get(item).includes(word); });
        item.hidden = !match;
        if (match) matches++;
        if (query) item.open = match;
        else if (previousQuery) item.open = openBeforeSearch.has(item);
      });
      groups.forEach(function (group) {
        group.hidden = !Array.from(group.querySelectorAll('[data-faq-item]')).some(function (item) { return !item.hidden; });
      });
      categories.forEach(function (link) {
        var heading = document.getElementById(link.dataset.faqCategory);
        link.parentElement.hidden = heading ? heading.closest('[data-faq-group]').hidden : false;
      });
      count.textContent = (matches === 1 ? count.dataset.countOne : count.dataset.countMany).replace('[count]', String(matches));
      empty.hidden = matches > 0;
      previousQuery = query;
    }

    function reset() {
      input.value = '';
      filter();
      input.focus();
    }

    function revealHash() {
      var id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (error) { return; }
      if (!id) return;
      var target = document.getElementById(id);
      if (!target || !section.contains(target)) return;
      if (input.value) { input.value = ''; filter(); }
      var detail = target.closest('[data-faq-item]');
      if (detail) detail.open = true;
      target.scrollIntoView({ block: 'start' });
    }

    input.addEventListener('input', filter);
    section.querySelector('[data-faq-clear]').addEventListener('click', reset);
    section.querySelector('[data-faq-reset]').addEventListener('click', reset);
    window.addEventListener('hashchange', revealHash);
    search.hidden = false;
    filter();
    if (window.location.hash) revealHash();
  }

  document.querySelectorAll('[data-netrition-faq]').forEach(initFAQ);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-netrition-faq]').forEach(initFAQ);
  });
})();
